var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget-image"},[_c('div',{staticClass:"image-container"},[_c('ImageUrl',{attrs:{"file-id":_vm.fileId,"size":_vm.FileSize.THUMBNAIL}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }